// ** React Imports
import { useState, useEffect } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Divider,
  Modal,
  InputLabel,
  Paper,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ReactSelect from "react-select";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SendIcon from "@mui/icons-material/Send";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import SearchIcon from "@mui/icons-material/Search";
import DentistUse from "../DentistUse";
import OSAPAGE from "../Osapage";
import Letter from "../Letter";
import PatientsQuestionaire from "../PatientsQuestionaire";
import ConsentForm from "./ConsentForm";
import LetterForm from "./LetterForm";
import DentistForm from "./DentistForm";
import LetterOfNecessityForm from "./LetterOfNecessityForm";
import AffidavitForm from "./AffidavitForm";
import CancelIcon from "@mui/icons-material/Cancel";
import TMDQUESTIONNAIRE from "./TMDQUESTIONNAIRE";

const PatientsForms = (props) => {
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    minHeight: "5px !important",
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "&.MuiDataGrid-root .custom-column-header .MuiDataGrid-colCellTitle": {
      lineHeight: "20px !important", // Adjust this value to decrease the header height
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
      // minHeight:'5px !important'

      // height: '35px !important',
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const [refresh, setRefresh] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [FormId, setFormId] = useState(0);
  const [rowId, setrowId] = useState(0);
  const [createdDate, setcreatedDate] = useState("");
  const [patientView, setpatientView] = useState("");
  const [completed, setcompleted] = useState("");
  const [createdBy, setcreatedBy] = useState("");
  const [selectedFormOpen, setSelectedFormOpen] = useState("");
  const handleFormClick = (formName) => {
    setSelectedFormOpen(formName);
    setOpenModal(true);
  };
  const handleClose = () => {
    setSelectedFormOpen("");
    setOpenModal(false);
    setsendToPortal(false);
  };

  const PatientId = props.patientId;
  const PatientINFO = props.Patientinfo;
  const renderFormContent = () => {
    switch (selectedFormOpen) {
      case "SCREENER":
        return (
          <LetterForm
            FormPatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientName={props.PatientName}
            onFormSubmit={(id) => {
              setFormId(id);
              if (id) {
                handleSave(id);
              }
            }}
          />
        );
      case "DENTISTS":
        return (
          <DentistForm
            FormPatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientName={props.PatientName}
            onFormSubmit={(id) => {
              setFormId(id);
              if (id) {
                handleSave(id);
              }
            }}
          />
        );
      case "LETTER":
        return (
          <LetterOfNecessityForm
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={(id) => {
              setFormId(id);
              if (id) {
                handleSave(id);
              }
            }}
          />
        );
      case "QUESTIONNAIRES":
        return (
          <PatientsQuestionaire
            patientId={PatientId}
            Patientinfo={props.Patientinfo}
            OtherPatientInfo={props.OtherPatientInfo}
            handleClose={handleClose}
            FormId={FormId}
            onFormSubmit={(data) => {
              setFormId(data);
              if (data) {
                handleSave(data);
              }
            }}
          />
        );
      case "INFORMED_CONSENT":
        return (
          <ConsentForm
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientName={props.PatientName}
            onFormSubmit={(data) => {
              setFormId(data.id);
              if (data.id) {
                handleSave(data.id);
              }
            }}
          />
        );
      case "AFFIDAVIT_CPAP_DEVICE":
        return (
          <AffidavitForm
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={(data) => {
              setFormId(data);
              if (data) {
                handleSave(data);
              }
            }}
          />
        );
  case"TMD-TMJ-PATIENT-QUESTIONNAIRE":
  return (
          // <AffidavitForm
          //   PatientId={PatientId}
          //   FormId={FormId}
          //   handleClose={handleClose}
          //   PatientDob={PatientINFO?.dob}
          //   PatientName={props.PatientName}
          //   onFormSubmit={(data) => {
          //     setFormId(data);
          //     if (data) {
          //       handleSave(data);
          //     }
          //   }}
          // />
          <TMDQUESTIONNAIRE
           PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={(data) => {
              setFormId(data);
              if (data) {
                handleSave(data);
              }
            }}
          />
        );
      default:
        return <div>No Page Found</div>;
    }
  };
  const [selectedForm, setSelectedForm] = useState("");
  const [sendToPortal, setsendToPortal] = useState(false);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    // {
    //   field: "patientId",
    //   headerName: "Patient ID",
    //   cellClassName: "gridCell",
    //   sortable: false,
    //   headerClassName: "super-app-theme--header",
    //   flex: 0.3,
    // },
    {
      field: "formName",
      headerName: "Form Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      renderCell: (cellValues) => (
        <Button
          onClick={() => {
            handleFormClick(cellValues.row.formName);
            setrowId(cellValues.row.id);
            setSelectedForm(cellValues.row.formName);
            // setFormId(cellValues.row.formId);
            setFormId(cellValues.row.formId ?? 0);
            setcreatedDate(cellValues.row.createdDate);
            setcreatedBy(cellValues.row.createdBy);
            setsendToPortal(cellValues.row.sentToPortal);
            setpatientView(cellValues.row.patientView)
            setcompleted(cellValues.row.completed)
          }}
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
        >{`${cellValues.row.formName}`}</Button>
      ),
    },
    {
      field: "sentToPortal",
      headerName: "Sent",
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {params.row.sentToPortal ? (
            <CheckCircleIcon style={{ color: "green" }} />
          ) : (
            <CancelIcon style={{ color: "red" }} />
          )}
        </div>
      ),
    },
    {
      field: "Send",
      headerClassName: "super-app-theme--header",
      headerName: "Send",
      flex: 0.15,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          startIcon={<SendIcon />}
          sx={{
            width: "170px", // uniform width
            background: !params.row.sentToPortal
              ? "#4CAF50" // green for reset password
              : "#2196F3", // blue for invite
            color: "#fff",
            borderRadius: "20px",
            fontWeight: 300,
            fontSize: "0.55rem",
            textTransform: "none",
            transition: "all 0.25s ease",
          }}
          disabled={params.row.sentToPortal}
          onClick={() => {
            const postData = {
              id: params.row.id,
              patientId: params.row.patientId,
              formName: params.row.formName,
              formId: params.row.formId,
              sentToPortal: true,
              createdDate: params.row.createdDate,
              patientView: params.row.patientView,
              inActive: false,
            };
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
                postData,
                { headers }
              )
              .then(() => {
                Swal.fire({
                  icon: "success",
                  title: "Sent!",
                  text: "Form sent to portal successfully.",
                showConfirmButton: false,
                timer: 1200,
                });
                setRefresh((prev) => !prev);
              })
              .catch((err) => {
                console.error(err);
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Failed to send to portal.",
                });
              });
          }}
        >
          {!params.row.sentToPortal ? "SEND" : "SENT"}
        </Button>
      ),
    },
   {
  field: "Notify",
  headerClassName: "super-app-theme--header",
  headerName: "Notify via Email",
  flex: 0.15,
  renderCell: (params) => (
    <Button
      variant="contained"
      size="small"
      sx={{
        width: "160px",
        background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
        color: "#fff",
        borderRadius: "25px",
        fontWeight: 500,
        fontSize: "0.65rem",
        textTransform: "none",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.25)",
          background: "linear-gradient(135deg, #2575fc 0%, #6a11cb 100%)",
        },
      }}
    onClick={() => {
  axios
    .post(
      `${process.env.REACT_APP_API_URL}/PatientForms/sendPatientPortalEmail?patientId=${params.row.patientId}`,null,
      { headers }
    )
    .then((response) => {
      const res = response;
      if (res.success) {
        Swal.fire({
          icon: "success",
          title: "Notification Sent!",
          text: res.message, // "Patient has been notified via email."
           showConfirmButton: false,
                timer: 1200,
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: res.message, // "Patient not found" or "Email not available"
          confirmButtonColor: "#FFA500",
        });
      }
    })
    .catch((err) => {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to send email notification.",
      });
    });
}}

    >
      Notify via Email
    </Button>
  ),
}
,
    {
      field: "createdDate",
      headerName: "Send Date",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (params) =>
        params.value ? moment(params.value).format("MM/DD/YYYY") : "",
    },
    // {
    //   field: "updatedDate",
    //   headerName: "Updated Date",
    //   cellClassName: "gridCell",
    //   sortable: false,
    //   headerClassName: "super-app-theme--header",
    //   flex: 0.1,
    //   renderCell: (params) =>
    //     params.value ? moment(params.value).format("MM/DD/YYYY") : "",
    // },
 {
      field: "completed",
      headerName: "Completed",
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {params.row.completed ? (
            <CheckCircleIcon style={{ color: "green" }} />
          ) : (
            <CancelIcon style={{ color: "red" }} />
          )}
        </div>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (cell) => (
        <DeleteIcon
          style={{
            marginRight: "3px",
            float: "right",
            marginTop: "5px",
            color: "red",
            marginleft: "4px",
          }}
          color="black"
          // onClick={(cellValues) => {
          //   // console.log('Cell: ', cell)
          //   confirmAlert({
          //     message: "Do you want to delete the record.",
          //     closeOnEscape: true,
          //     closeOnClickOutside: true,
          //     overlayClassName: "overlay-custom-class-name",
          //     buttons: [
          //       {
          //         label: "Yes",
          //         onClick: () => {
          //           const postData = {
          //             id: cell.row.id,
          //             inActive: true,
          //             patientView: cell.row.patientView,
          //           };

          //           axios
          //             .post(
          //               `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
          //               postData,
          //               {
          //                 headers,
          //               }
          //             )
          //             .then((response) => {
          //               setRefresh(!refresh);
          //               // setOpenNote(false)
          //               // console.log('response.data: ', response.data)
          //             })
          //             .catch((error) => {
          //               console.error("There was an error!", error);
          //             });
          //         },
          //       },
          //       {
          //         label: "No",
          //       },
          //     ],
          //   });
          // }}
               onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to delete the record?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#6c7c84",
                    heightAuto: false,
                    backdrop: true,
                    didOpen: () => {
                      const popup = document.querySelector(".swal2-popup");
                      const container = document.querySelector(".swal2-container");
                      const backdrop = document.querySelector(".swal2-backdrop");
          
                      if (popup) popup.style.zIndex = "1801";
                      if (container) container.style.zIndex = "1801";
                      if (backdrop) backdrop.style.zIndex = "1800";
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      const postData = {
                        id: cell.row.id,
                      inActive: true,
                      patientView: cell.row.patientView,
                      };
          
                      axios
                        .post(`${process.env.REACT_APP_API_URL}/PatientForms/AddForm`, postData, { headers })
                        .then(() => {
                          setRefresh(!refresh);
          
                          Swal.fire({
                            title: "Deleted!",
                            text: "Record deleted successfully.",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 1200,
                            heightAuto: false,
                          });
                        })
                        .catch((error) => {
                          console.error("There was an error!", error);
          
                          Swal.fire({
                            title: "Error!",
                            text: "Something went wrong.",
                            icon: "error",
                            heightAuto: false,
                          });
                        });
                    }
                  });
                }}
        ></DeleteIcon>
      ),
    },
  ];

  const [rows, setRows] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    setLoading(true);
    // POST request using axios inside useEffect React hook
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientForms/GetFormByPatientId?patientId=${PatientId}`,
        { headers }
      )
      .then((response) => {
        setLoading(false);
        setRows(response);
      })
      .catch((error) => {});
  }, [refresh, PatientId]);

  const [OpenNewForm, setOpenNewForm] = useState(false); // Modal state

  const handleOpenNewForm = () => {
    setOpenNewForm(true);
    setrowId(0);
  };

  const handleCloseNewForm = () => {
    setOpenNewForm(false);
    setSelectedForm("");
    setsendToPortal(false);
    setFormId(0);
    setSelectedFormOpen("");
  };
  const [searchText, setSearchText] = useState("");

  const formOptions = [
    { label: "QUESTIONNAIRES", value: "QUESTIONNAIRES" },
    { label: "SCREENER", value: "SCREENER" },
    { label: "LETTER", value: "LETTER" },
    { label: "DENTISTS", value: "DENTISTS" },
    { label: "INFORMED CONSENT", value: "INFORMED_CONSENT" },
    {
      label: "AFFIDAVIT FOR INTOLERANCE TO CPAP DEVICE",
      value: "AFFIDAVIT_CPAP_DEVICE",
    },
     {
      label: "TMD-TMJ-PATIENT-QUESTIONNAIRE",
      value: "TMD-TMJ-PATIENT-QUESTIONNAIRE",
    },
  ];
  const filteredOptions = formOptions.filter((option) =>
    option.label.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleCheckboxClick = (optionValue) => {
    // Single selection logic
    if (selectedForm === optionValue) {
      setSelectedForm(""); // Uncheck if already selected
    } else {
      setSelectedForm(optionValue);
    }
  };
  // useEffect(() => {
  //   if (FormId) {
  //     handleSave(FormId);
  //   }
  // }, [FormId]);
  const handleSave = async (formId) => {
    const postData = {
      id: rowId,
      patientName: props.PatientName,
      patientId: PatientId,
      sentToPortal: sendToPortal,
      formName: selectedForm,
      formId: formId,
      inActive: false,
      // createdDate:createdDate
      ...(createdDate
        ? { createdDate: createdDate, createdBy: createdBy }
        : {}),
         ...(patientView
        ? { patientView: patientView }
        : {patientView: false }),
         ...(completed
        ? { completed: completed }
        : {}),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
        postData,
        { headers }
      );
      setSelectedForm("");
      handleCloseNewForm();

      Swal.fire({
        icon: "success",
        title: "Form Added!",
        html: `<p>This Form is Added.</p>`,
       timer: 2000, // 2 seconds
  showConfirmButton: false,
  timerProgressBar: true,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });

      setRefresh((prev) => !prev);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try againss."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    }
  };

  return (
    <Container>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "89%", sm: "70%", md: "75%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "84vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              {selectedFormOpen}
            </Typography>

            <IconButton
              onClick={handleClose}
              sx={{
                color: "#00695C", // dark teal for icon
                backgroundColor: "#C6F3DD", // minty soft green background
                transition: "0.3s",
                "&:hover": { backgroundColor: "#00695C", color: "#FFFFFF" }, // inverted hover
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={1}>
            {renderFormContent()}
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={OpenNewForm}
        onClose={handleCloseNewForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "85%", sm: "70%", md: "60%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "84vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              Send New From
            </Typography>

            <IconButton
              onClick={handleCloseNewForm}
              sx={{
                color: "#00695C", // dark teal for icon
                backgroundColor: "#C6F3DD", // minty soft green background
                transition: "0.3s",
                "&:hover": { backgroundColor: "#00695C", color: "#FFFFFF" }, // inverted hover
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/* <Box p={3} component={Paper} elevation={3}> */}
          <Grid container spacing={1}>
            {/* Patient Name */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Patient Name
              </Typography>
              <Paper
                elevation={1}
                sx={{
                  padding: 1.5,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#333",
                }}
              >
                {props.PatientName || "N/A"}
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Forms
              </Typography>
              <FormControl component="fieldset" fullWidth>
                {/* <Grid container spacing={1}> */}
                <Grid item xs={12} container justifyContent="center">
                  <TextField
                    placeholder="SEARCH FORMS..."
                    variant="outlined"
                    size="small"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#377562", fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      width: { xs: "90%", sm: "70%", md: "50%" },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                        backgroundColor: "#F9FCFB",
                        transition: "0.3s ease",
                        "& fieldset": {
                          borderColor: "#9BC7B0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#377562",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#00695C",
                          boxShadow: "0 0 6px rgba(55,117,98,0.3)",
                        },
                      },
                      "& input": {
                        fontSize: "0.9rem",
                        padding: "8px 10px",
                        textTransform: "uppercase", // 🔥 UPPERCASE TEXT
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#6b6b6b",
                        opacity: 0.8,
                        textTransform: "uppercase",
                      },
                    }}
                  />
                </Grid>

                {filteredOptions.map((option, index) => (
                  <Grid item xs={12} key={index}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={selectedForm === option.value}
                          onClick={() => handleCheckboxClick(option.value)}
                        />
                      }
                      label={option.label}
                      sx={{
                        marginY: 0.1, // vertical spacing
                        fontSize: "0.55rem", // smaller font
                      }}
                    />
                  </Grid>
                ))}
                {/* </Grid> */}
              </FormControl>
            </Grid>

            {/* Buttons */}
            <Grid item xs={12} container spacing={2} justifyContent="flex-end">
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  style={{ height: "40px", fontSize: "14px", color: "white" }}
                  onClick={() => handleSave(0)}
                >
                  Send
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  style={{ height: "40px", fontSize: "14px", color: "white" }}
                  onClick={handleCloseNewForm}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {/* </Box> */}
        </Box>
      </Modal>
      <Grid container>
        <Grid item xs={12}>
          <Button
            sx={{ mb: 1 }}
            className="Button"
            variant="contained"
            onClick={handleOpenNewForm}
          >
            <AddOutlinedIcon
              fontSize="small"
              style={{
                color: "white",
                paddingRight: "4px",
                paddingBottom: "2px",
                float: "right",
              }}
            ></AddOutlinedIcon>
            Send Form to Patient Portal
          </Button>
        </Grid>
        {/* <Grid item xs={8}>
          <Box display="flex" justifyContent="center" mb={2}>
            <TextField
              placeholder="Search Forms..."
              variant="outlined"
              size="small"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#377562", fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                width: { xs: "90%", sm: "70%", md: "50%" }, // responsive width
                "& .MuiOutlinedInput-root": {
                  borderRadius: "25px",
                  backgroundColor: "#F9FCFB",
                  transition: "0.3s ease",
                  "& fieldset": {
                    borderColor: "#9BC7B0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#377562",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#00695C",
                    boxShadow: "0 0 6px rgba(55,117,98,0.3)",
                  },
                },
                "& input": {
                  fontSize: "0.9rem",
                  padding: "8px 10px",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#6b6b6b",
                  opacity: 0.8,
                },
              }}
            />
          </Box>
        </Grid> */}
      </Grid>

      <Box mb={3} marginTop={2}>
        {isLoading ? (
          <div style={{ margin: "5rem", textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div style={{ height: 400, width: "100%" }}>
            {rows === null || rows.length === 0 ? (
              <Typography>No Record found</Typography>
            ) : (
              <DataGrid
                rows={rows}
                classes={gridClasses}
                columns={columns}
                // getRowSpacing={getRowSpacing}
                //checkboxSelection
                fullWidth
                pagination
                pageSizeOptions={[25]}
                sx={gridRowStyle}
                rowHeight={30}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 25, page: 0 },
                  },
                }}
              />
            )}
          </div>
        )}
      </Box>
    </Container>
  );
};

export default PatientsForms;
